<template>
    <div class="evaluation-page">
        <div class="evaluation-modal" v-if="tipStatus" @touchmove.prevent>
            <div class="tip-wrapper">
                <img src="../assets/images/evaluation_success_pic@3x.png">
                <h2>评价成功，感谢您的反馈！</h2>
                <span>您的评价将作为我们衡量工程师<br/>服务质量的重要参考依据！</span>
                <div class="check" @click="goOrderList">查看评价</div>
                <p>继续下单</p>
            </div>
        </div>
        <div class="main-wrapper">
            <mt-header fixed title="发表评价" style="background:#ffffff;color:#262626;">
                <router-link to="/" slot="left">
                    <mt-button icon="back"></mt-button>
                </router-link>
            </mt-header>

            <div class="scroll-wrapper">
                <div class="scroll-content">
                    <ul class="content">
                        <li class="complete">
                            <div class="title">
                                <img src="../assets/images/evaluation_data_icon@3x.png">
                                <span>您是否得到了您想要的数据?</span>
                            </div>
                            <ul>
                                <li class="get" :class="{'active':completeType == 1}" @click="changeCompleteType(1)">
                                    <div class="img"></div>
                                    <span>得到了</span>
                                </li>
                                <li class="none" :class="{'active':completeType == 2}" @click="changeCompleteType(2)">
                                    <div class="img"></div>
                                    <span>没得到</span>
                                </li>
                                <li class="notget" :class="{'active':completeType == 4}" @click="changeCompleteType(4)">
                                    <div class="img"></div>
                                    <span>不清楚</span>
                                </li>
                            </ul>
                        </li>
                        <li class="satisfied">
                            <div class="title">
                                <img src="../assets/images/evaluation_eng_icon@3x.png">
                                <div class="text">
                                    <p>{{eng_no}}号工程师</p>
                                    <span>请给为您提供服务的工程师打分</span>
                                </div>
                            </div>
                            <ul>
                                <li class="great" :class="{'active':satisfiedType == 90}" @click="changeSatisfiedType(90)">
                                    <div class="img"></div>
                                    <span>超赞</span>
                                </li>
                                <li class="soso" :class="{'active':satisfiedType == 60}" @click="changeSatisfiedType(60)">
                                    <div class="img"></div>
                                    <span>一般</span>
                                </li>
                                <li class="bad" :class="{'active':satisfiedType == 30}" @click="changeSatisfiedType(30)">
                                    <div class="img"></div>
                                    <span>非常差</span>
                                </li>
                            </ul>
                        </li>
                        <li class="suggestion">
                            <textarea placeholder="请说出您的意见和想法，您的意见就是我们改正的动力。" v-model="content"></textarea>
                        </li>
                    </ul>

                    <div class="submit" v-if="submitAbled" @click="submitComment">
                        提交评价
                    </div>

                    <div class="submit disabled" v-if="!submitAbled">
                        提交评价
                    </div>
                </div>
            </div>

            
        </div>
        
    </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {

    data(){
        return{
            eng_no: '',
            service_no: '',
            completeType: 0,
            satisfiedType: 0,
            content: '',
            submitAbled: false,
            tipStatus: false,
            comment_id: ''
        }
    },
    watch:{
        completeType: function(val){
            this.vaildInput()
        },
        satisfiedType: function(val){
            this.vaildInput()
        }
    },
    methods:{
        goOrderList(){
            this.$router.push({name:'orderList',query:{comment_id:this.comment_id}})
        },
        submitComment(){
            let access_token = localStorage.access_token
            let data = {
                info: {
                    service_no: this.service_no,
                    eng_score: this.satisfiedType,
                    data_recovered: this.completeType,
                },
                access_token: access_token
            }
            if(this.content!=''){
                data.info['content'] = this.content
            }
            this.$store.dispatch('orderComment',data).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.tipStatus = true
                    this.comment_id = result.res.id
                }
            })
        },
        changeCompleteType(type){
            this.completeType = type
        },
        changeSatisfiedType(type){
            this.satisfiedType = type
        },
        vaildInput(){
            if(this.completeType != 0 && this.satisfiedType != 0){
                this.submitAbled = true
            }else {
                this.submitAbled = false
            }
        }
    },
    components:{

    },
    mounted(){

    },
    created(){
        this.eng_no = this.$route.query.eng_no
        this.service_no = this.$route.query.service_no
    },
    filter: {
        
    }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Evaluation.vue